export default __webpack_public_path__ + "static/media/close-up-computer.2723cb7e.jpg";